import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { cleanImage } from "@/services/imageHandling";
import Image from "next/image";

const BlogSingle = () => {
  const { blogSingle, error } = useSelector((state) => state.blogSingle);
  const blog_cat = blogSingle[0]?.attributes?.add_blog_categories?.data;
  // console.log('single',blogSingle);
  const date = new Date(blogSingle[0]?.attributes?.Date).toLocaleString(
    "default",
    { month: "long", day: "numeric", year: "numeric" }
  );
  const {
    asPath, // the value: "/blog/blog_uel"
    pathname, // the value: "/blog/[slug]"
  } = useRouter();
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <>
      <section className="sec-padd">
        <div className="container">
          <div className="row mr0">
            <div className="col-sm-12 col-md-12">
              <div className="blog_tittle">
                <h1 className="blog_head">
                  {blogSingle[0]?.attributes?.Title}
                </h1>
              </div>

              <div className="post_detail">
                <ul>
                  <li>
                    <Image
                      width={20}
                      height={20}
                      src="../images/user.svg"
                      alt="user"
                    />
                    By Admin
                  </li>
                  <li>
                    <Image
                      width={20}
                      height={20}
                      src="../images/calender.svg"
                      alt="NewKolkata blog date"
                    />
                    {isClient ? date : "Prerendered"}
                  </li>
                  <li>
                    <Image
                      src="../images/category.svg"
                      alt="NewKolkata Blog category"
                      width={20}
                      height={20}
                    />
                    {blog_cat &&
                      blog_cat.map((item, index) => {
                        return (
                          <span key={"cat_key" + index}>
                            {(index ? ", " : "") +
                              item?.attributes?.categoryname}
                          </span>
                        );
                      })}
                  </li>
                </ul>
              </div>
              <div className="post_img">
                <Image
                  fill
                  src={cleanImage(
                    blogSingle[0]?.attributes?.Postimage?.data?.attributes?.url
                  )}
                  alt="post image"
                  className="image"
                />
              </div>
              <div className="blog_txt_wrap">
                <div
                  dangerouslySetInnerHTML={{
                    __html: blogSingle[0]?.attributes?.PostData,
                  }}
                ></div>
              </div>
            </div>
            {/* <div className="col-sm-12 col-md-3">
              <BlogSidebar />
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogSingle;
